import React, { useEffect } from "react";
import { Flex, Image } from "antd";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import { clrs } from "../../constants/colors";
import ThreeImagesLayout from "./ThreeImagesLayout";
import InfoItem from "./InfoItem";
import Footer from "../components/Footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import professions from "./professions.json";
import img1 from "../../images/photo/3x/1.png";
import img2 from "../../images/photo/3x/2.png";
import img3 from "../../images/photo/3x/3.png";
import img4 from "../../images/photo/3x/4.png";
import img5 from "../../images/photo/3x/5.png";
import img6 from "../../images/photo/3x/6.png";
import img7 from "../../images/photo/3x/7.png";
import img8 from "../../images/photo/3x/8.png";
import img9 from "../../images/photo/3x/9.png";
import img10 from "../../images/photo/3x/10.png";
import img11 from "../../images/photo/3x/11.png";
import img12 from "../../images/photo/3x/12.png";
import img13 from "../../images/photo/3x/13.png";
import img14 from "../../images/photo/3x/14.png";
import img15 from "../../images/photo/3x/15.png";
import img16 from "../../images/photo/3x/16.png";
import img17 from "../../images/photo/3x/17.png";
import img18 from "../../images/photo/3x/18.png";
import img19 from "../../images/photo/3x/19.png";
import img20 from "../../images/photo/3x/20.png";
import img21 from "../../images/photo/3x/21.png";
import img22 from "../../images/photo/3x/22.png";
import img23 from "../../images/photo/3x/23.png";
import img24 from "../../images/photo/3x/24.png";
import img25 from "../../images/photo/3x/25.png";
import img26 from "../../images/photo/3x/26.png";
import img27 from "../../images/photo/3x/27.png";
import img28 from "../../images/photo/3x/28.png";
import img29 from "../../images/photo/3x/29.png";
import img30 from "../../images/photo/3x/30.png";
import img31 from "../../images/photo/3x/31.png";
import img32 from "../../images/photo/3x/32.png";
import img33 from "../../images/photo/3x/33.png";
import img34 from "../../images/photo/3x/34.png";
import img35 from "../../images/photo/3x/35.png";
import img36 from "../../images/photo/3x/36.png";
import img37 from "../../images/photo/3x/37.png";
import img38 from "../../images/photo/3x/38.png";
import img39 from "../../images/photo/3x/39.png";
import img40 from "../../images/photo/3x/40.png";
import img41 from "../../images/photo/3x/41.png";
import img42 from "../../images/photo/3x/42.png";
import img43 from "../../images/photo/3x/43.png";
import img44 from "../../images/photo/3x/44.png";
import img45 from "../../images/photo/3x/45.png";
import img1White from "../../images/icon/white/Ресурс 15@3x.png";
import img2White from "../../images/icon/white/B - 77,  plug, electric, electric, cord, charge@3x.png";
import img3White from "../../images/icon/white/Ресурс 5@3x.png";
import img4White from "../../images/icon/white/Ресурс 11@3x.png";
import img5White from "../../images/icon/white/Ресурс 13@3x.png";
import img6White from "../../images/icon/white/Ресурс 8@3x.png";
import img7White from "../../images/icon/white/Ресурс 10@3x.png";
import img8White from "../../images/icon/white/Ресурс 7@3x.png";
import img9White from "../../images/icon/white/Ресурс 14@3x.png";
import img10White from "../../images/icon/white/Ресурс 6@3x.png";
import img11White from "../../images/icon/white/B - 87, blueprint, Architecture, blue print, construction, paper, plan@3x.png";
import img12White from "../../images/icon/white/Ресурс 9@3x.png";
import img13White from "../../images/icon/white/Ресурс 4@3x.png";
import img14White from "../../images/icon/white/Ресурс 12@3x.png";
import img15White from "../../images/icon/white/Ресурс 1@3x.png";

const ProfessionPage = () => {
  const { number } = useParams();

  const navigate = useNavigate();

  function getImages(number) {
    const num = Number(number);

    // Check if the input is a valid number
    if (isNaN(num)) {
      return;
    }

    // Return different arrays of images based on the number
    if (num === 1) {
      return [img1, img2, img3, img1White];
    } else if (num === 2) {
      return [img7, img8, img9, img3White];
    } else if (num === 3) {
      return [img4, img5, img6, img2White];
    } else if (num === 4) {
      return [img10, img11, img12, img4White];
    } else if (num === 5) {
      return [img13, img14, img15, img5White];
    } else if (num === 6) {
      return [img16, img17, img18, img6White];
    } else if (num === 7) {
      return [img19, img20, img21, img7White];
    } else if (num === 8) {
      return [img22, img23, img24, img8White];
    } else if (num === 9) {
      return [img25, img26, img27, img9White];
    } else if (num === 10) {
      return [img28, img29, img30, img10White];
    } else if (num === 11) {
      return [img31, img32, img33, img11White];
    } else if (num === 12) {
      return [img34, img35, img36, img12White];
    } else if (num === 13) {
      return [img37, img38, img39, img13White];
    } else if (num === 14) {
      return [img40, img41, img42, img14White];
    } else if (num === 15) {
      return [img43, img44, img45, img15White];
    }

    // Return an empty array or undefined if the number is not between 1 and 15
    return [];
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function isStringBetween1And15(str) {
    // Convert the string to a number
    const num = Number(str);

    // Check if the conversion resulted in a valid number and if it's between 1 and 15
    if (!isNaN(num) && num >= 1 && num <= 15) {
      return true;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (!isStringBetween1And15(number)) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isStringBetween1And15(number)) {
    return "";
  }

  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align={"center"}
      justify={"flex-start"}
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          position: "relative",
          paddingTop: 200,
          paddingBottom: 50,
        }}
        vertical
        gap={50}
        align={"center"}
        justify={"flex-start"}
      >
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          wrap={"wrap"}
          gap={20}
          align={"flex-start"}
          justify={"center"}
        >
          <ThreeImagesLayout
            img1={getImages(number)[0]}
            img2={getImages(number)[1]}
            img3={getImages(number)[2]}
          />
        </Flex>
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          wrap={"wrap"}
          gap={20}
          align={"flex-start"}
          justify={"center"}
        >
          <Flex
            style={{
              width: "100%",
              padding: 10,
              backgroundColor: clrs.blackerBlue,
            }}
            align={"center"}
            justify={"flex-start"}
            gap={10}
          >
            <MyText strong size={"large"} style={{ color: "white" }}>
              {professions[`${number}`].name}{" "}
            </MyText>
            <Flex
              style={{
                width: 100,
                height: 100,
                borderRadius: "100%",
                backgroundColor: clrs.blackerBlue,
                padding: 5,
                position: "absolute",
                right: 10,
              }}
              align={"center"}
              justify={"center"}
            >
              <Image preview={false} src={getImages(number)[3]} width={45} />
            </Flex>
          </Flex>
        </Flex>
        <Flex
          style={{ width: "100%", maxWidth: 1440, position: "relative" }}
          wrap={"wrap"}
          align={"flex-start"}
          justify={"flex-start"}
        >
          {professions[`${number}`].upperTexts.map((upperText, i) => {
            return (
              <MyText
                key={new Date() + i + "upperText"}
                style={{ textAlign: "justify", color: clrs.blackerBlue }}
              >
                {upperText}
              </MyText>
            );
          })}
        </Flex>
        {professions[`${number}`].items.map((item, i) => {
          return (
            <InfoItem
              key={new Date() + i}
              number={item.number}
              textUp={item.upText}
              textCenter={item.centerText}
              textBottom={item.bottomText}
            />
          );
        })}
      </Flex>
      <Flex
        style={{
          width: "100%",
          maxWidth: 800,
          position: "relative",
          paddingBottom: 50,
        }}
        vertical
        align={"flex-start"}
        justify={"flex-start"}
      >
        {professions[`${number}`].bottomTexts.map((bottomText, i) => {
          return (
            <MyText
              key={new Date() + i + "upperText"}
              style={{ textAlign: "justify", color: clrs.blackerBlue }}
            >
              {bottomText}
            </MyText>
          );
        })}
      </Flex>
      <Footer />
    </Flex>
  );
};

export default ProfessionPage;
